


































import {
  Component, Prop, Vue, Watch,
} from 'vue-property-decorator';

@Component
export default class TouristSpots extends Vue {
  @Prop()
  prefName!: number

  @Prop()
  city!: number

  @Prop()
  spotData!: any[]

  image = new Image();

  isLoadedSuccess: boolean = false

  @Watch('spotData')
  watchSpotData() {
    if (this.spotData) {
      this.image.src = this.spotData[0].mapImg;
      this.image.onload = () => {
        this.isLoadedSuccess = true;
        this.$emit('isLoadedSuccess');
      };
    }
  }

  get externalLink() {
    return `http://www.jalan.net/kankou/cit_${this.city}0000/`;
  }
}
